import type { ReactNode } from "react";

import { StyledIntroInnerWrapper, StyledIntroPage } from "./styles";

type Props = {
    children: ReactNode;
};

const IntroIntentSignalPage = (props: Props) => {
    return (
        <StyledIntroPage>
            <StyledIntroInnerWrapper>{props.children}</StyledIntroInnerWrapper>
        </StyledIntroPage>
    );
};

export default IntroIntentSignalPage;
